<section id="inventory-records">
  <div class="flex flex-col-reverse sm:flex-row gap-2 mb-8">

    <div class="flex-grow mb-2">
      <div>
        <nz-collapse>
          <nz-collapse-panel [nzHeader]="'Advanced Search'">
            <div class="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
              <div class="flex flex-col xl:flex-row md:items-start gap-2 xl:gap-0">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton">
                  <input type="text" [(ngModel)]="searchText" (keydown.enter)="search()" nz-input placeholder="Search here"/>
                </nz-input-group>

                <ng-template #suffixIconSearchButton>
                  <button nz-button nzType="primary" nzSearch class="bg-[#6B6C6E] border-[#6B6C6E]" (click)="search()">
                    <span nz-icon nzType="search"></span>
                  </button>
                </ng-template>
                <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>
              </div>

              <nz-range-picker
                [(ngModel)]="dateFilter"
                (ngModelChange)="onChangeDateFilter($event)"
              ></nz-range-picker>

              <div>
                <button nz-button nzBlock class="outline-button" (click)="resetSearch()">
                  Reset All
                </button>
              </div>

            </div>
          </nz-collapse-panel>
        </nz-collapse>

      </div>
    </div>

    <button *appHasAnyPrivilege="'INVENTORY_RECORDS_CREATE'" nz-button nzType="primary"
            (click)="navigateNewInventory()" [disabled]="inventoryData[1]?.after?.user === undefined || searched || inventoryData[0]?.after?.inspectionDetails?.reason === 'Final'">
      New Inspection Record
    </button>

  </div>


  <div class="table-card">
    <div [ngClass]="loading ? 'hidden' : 'block'" class="table-obj">
      <nz-table
        #basicTable [nzData]="inventoryData" [nzShowSizeChanger]="pageSize.length > 5"
        [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
        [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
        (nzQueryParams)="onTableParamsChange($event)" [nzScroll]="{ x: 'auto', y: '550px' }" nzTableLayout="fixed"
        nzOuterBordered
      >
        <thead>
        <tr>
          <th>Inspection No</th>
          <th>Date and Time - Before</th>
          <th>Date and Time - After</th>
          <th>Done By - Before</th>
          <th>Done By - After</th>
          <th>Reason</th>
          <th>Booking Id</th>
          <th>Fuel Level - Before</th>
          <th>Fuel Level - After</th>
          <th>Odometer - Before</th>
          <th>Odometer - After</th>
          <th *appHasAnyPrivilege="'INVENTORY_RECORDS_UPDATE,INVENTORY_RECORDS_DELETE,INVENTORY_RECORDS_SINGLE_VIEW'">Actions
          </th>
        </tr>
        </thead>
        <tbody>

        <!--        Initial Inventory entry-->
        <tr *ngFor="let data of basicTable.data;  let i = index" class="align-baseline">
          <td style="white-space: nowrap;background-color: #FFE3D3; min-width: 150px"
              *ngIf="data.before?.inspectionDetails?.reason ==='Initial' || data.after?.inspectionDetails?.reason ==='Final'">
            <a *appHasAnyPrivilege="'INVENTORY_RECORDS_SINGLE_VIEW'"
               (click)="navToSingle(data)">{{data.inventoryId}}</a>
            <span *ngIf="!hasPermission('INVENTORY_RECORDS_SINGLE_VIEW')">{{data.inventoryId}}</span>
          </td>
          <td style="white-space: nowrap; min-width: 200px"
              *ngIf="data.before?.inspectionDetails?.reason !=='Initial' && data.after?.inspectionDetails?.reason !=='Final'">
            <a *appHasAnyPrivilege="'INVENTORY_RECORDS_SINGLE_VIEW'"
               (click)="navToSingle(data)">{{data.inventoryId}}</a>
            <span *ngIf="!hasPermission('INVENTORY_RECORDS_SINGLE_VIEW')">{{data.inventoryId}}</span>
          <td
            style="white-space: nowrap; min-width: 200px">{{ data.before.date ? (data.before.date | date:'yyyy-MM-dd | h:mm a') : '-' }}</td>
          <td
            style="white-space: nowrap; min-width: 200px">{{ data.after.date ? (data.after.date | date:'yyyy-MM-dd | h:mm a') : '-' }}</td>
          <td style="white-space: nowrap;  min-width: 200px">{{ data.before.user ? (data.before.user.name) : '-' }}</td>
          <td style="white-space: nowrap; min-width: 200px">{{ data.after.user ? data.after.user.name : '-' }}</td>

          <td style="white-space: nowrap; min-width: 200px"
              *ngIf="data.after.inspectionDetails?.reason !=='Final'">{{ data.before.inspectionDetails?.reason || '-' }}</td>
          <td style="white-space: nowrap; min-width: 200px"
              *ngIf="data.after.inspectionDetails?.reason==='Final'">{{ data.after.inspectionDetails?.reason || '-' }}</td>

          <td style="white-space: nowrap; min-width: 200px" *ngIf="data.before.inspectionDetails?.reason ==='Initial'">-</td>
          <td style="white-space: nowrap; min-width: 200px" *ngIf="data.before.inspectionDetails?.reason !=='Initial'">{{ data.before.inspectionDetails?.bookingDetails ? data.before.inspectionDetails?.bookingDetails?.bookingId : '-' }}</td>
          <td style="white-space: nowrap; min-width: 200px">{{ data.before.inspectionDetails?.fuelLevel + '%'}}</td>
          <td
            style="white-space: nowrap; min-width: 200px">{{ data.after.inspectionDetails ? (data.after.inspectionDetails?.fuelLevel + '%') : '-' }}</td>
          <td style="white-space: nowrap; min-width: 200px">{{ data.before.inspectionDetails?.Odometer + 'KM'}}</td>
          <td
            style="white-space: nowrap; min-width: 200px">{{ data.after.inspectionDetails ? (data.after.inspectionDetails?.Odometer + 'KM') : '-' }}</td>
          <td *appHasAnyPrivilege="'INVENTORY_RECORDS_UPDATE,INVENTORY_RECORDS_DELETE,INVENTORY_RECORDS_SINGLE_VIEW'"
              style="white-space: nowrap; min-width: 200px">
            <button *appHasAnyPrivilege="'INVENTORY_RECORDS_SINGLE_VIEW'" class="outline-button mr-3" nz-button
                    nzType="default" (click)="navToSingle(data)">
              View
            </button>

            <!-- Dropdown button -->
            <button *appHasAnyPrivilege="'INVENTORY_RECORDS_UPDATE,INVENTORY_RECORDS_DELETE'"
                    class="outline-button more-dropdown"
                    nz-button
                    nz-dropdown
                    [nzDropdownMenu]="menu"
                    nzPlacement="bottomCenter"
            >
              <span nz-icon nzType="more" nzTheme="outline"></span>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item nz-popconfirm nz-button (click)="afterInspection(data._id)"
                    *ngIf="hasPermission('INVENTORY_RECORDS_UPDATE') && (data.before.inspectionDetails?.reason !== 'Initial' && !data.after.inspectionDetails?.reason)">
                  Do After Inspection
                </li>
                <li nz-menu-item nz-popconfirm nz-button
                    *ngIf="hasPermission('INVENTORY_RECORDS_UPDATE') && (data.before.inspectionDetails?.reason === 'Initial' && !data.after.inspectionDetails)"
                    (click)="finalInspection(data._id)">Save To Final Records
                </li>
                <a
                  nz-popconfirm
                  nzPopconfirmTitle="Are you sure you want to delete this record?"
                  nzPopconfirmPlacement="bottom"
                  (nzOnConfirm)="deleteInventory(this.data._id)"
                >
                  <li
                    *ngIf="hasPermission('INVENTORY_RECORDS_DELETE') && (data.before.inspectionDetails?.reason !== 'Initial')"
                    nz-menu-item nz-popconfirm nz-button
                    nzDanger>Delete
                  </li>
                </a>
              </ul>
            </nz-dropdown-menu>
            
          </td>
        </tr>


        </tbody>
      </nz-table>
    </div>

  </div>
  <div [ngClass]="loading ? 'block' : 'hidden'">
    <app-table-skeleton-template [columnData]="skeletonTableColumns"
                                 [showAdvanceSearch]="false"></app-table-skeleton-template>
  </div>
</section>

